module.exports = __webpack_public_path__ + "static/media/success-icon.d15a588c.svg";